'use client';

import Link from 'next/link';
import { ActionIcon, Box, Container, Group, Text } from '@mantine/core';
import { IconBrandDiscord, IconBrandVk, IconBrandYoutube } from '@tabler/icons-react';
import { useTranslation } from '@/i18n/client';
import classes from './Footer.module.css';

const data = [
  {
    title: 'Useful',
    links: [
      { label: 'Download', link: '/download' },
      { label: 'News', link: '/news' },
      { label: 'Item DB', link: '/items/all' },
      {
        label: 'Toolbox',
        link: 'https://tera-asura.ru/static/files/TeraToolboxSetup.exe',
        noPrefetch: true,
      },
    ],
  },
  {
    title: 'Help',
    links: [
      { label: 'FAQ', link: '/faq' },
      { label: 'Terms', link: '/terms' },
      { label: 'Support', link: '/cabinet/support' },
      { label: 'MMOTOP', link: '/mmotop-guide' },
    ],
  },
  {
    title: 'Community',
    links: [
      { label: 'Discord', link: 'https://discord.com/invite/C3pcayddZj', noPrefetch: true },
      { label: 'VK', link: 'https://vk.com/tera_asura', noPrefetch: true },
      { label: 'YouTube', link: 'https://www.youtube.com/@AsuraTERA', noPrefetch: true },
    ],
  },
];

function FooterMenu() {
  const { t } = useTranslation('links');
  const groups = data.map((group) => {
    const links = group.links.map((link, index) => (
      <Link
        key={index}
        className={classes.link}
        href={link.link}
        prefetch={link?.noPrefetch ? false : 'auto'}
      >
        {t(link.label)}
      </Link>
    ));

    return (
      <Box className={classes.wrapper} key={group.title}>
        <Text className={classes.title}>{t(group.title)}</Text>
        {links}
      </Box>
    );
  });

  return groups;
}

export function Footer() {
  const { t } = useTranslation('footer');
  return (
    <Box className={classes.footer}>
      <Container className={classes.inner}>
        <Box className={classes.logo}>
          <Text size='xl' className={classes.name}>
            TERA: Asura
          </Text>
          <Text c='dimmed' className={classes.description}>
            {t('description')}
          </Text>
        </Box>
        <Box className={classes.groups}>
          <FooterMenu />
        </Box>
      </Container>
      <Container className={classes.afterFooter}>
        <Text c='dimmed' size='lg'>
          © 2019-{new Date().getFullYear()} Copyright: TERA Asura.
        </Text>

        <Group gap={0} className={classes.social} justify='flex-end' wrap='nowrap'>
          <ActionIcon size='lg' variant='subtle' color='gray' style={{ margin: 'auto 5px' }}>
            <Link href='https://vk.com/tera_asura' prefetch={false}>
              <IconBrandVk size={30} stroke={1.5} />
            </Link>
          </ActionIcon>
          <ActionIcon size='lg' variant='subtle' color='gray' style={{ margin: 'auto 5px' }}>
            <Link href='https://discord.com/invite/C3pcayddZj' prefetch={false}>
              <IconBrandDiscord size={30} stroke={1.5} />
            </Link>
          </ActionIcon>
          <ActionIcon size='lg' variant='subtle' color='gray' style={{ margin: 'auto 5px' }}>
            <Link href='https://www.youtube.com/@AsuraTERA' prefetch={false}>
              <IconBrandYoutube size={30} stroke={1.5} />
            </Link>
          </ActionIcon>
        </Group>
      </Container>
    </Box>
  );
}
